/**
 * Build API request payload from membership visit form state.
 */
import type { MembershipVisitRequest } from '../../types';
import { fromMantineDateString, toApiLocalDateTime } from '../mantineDateUtils';

export interface MembershipVisitFormState {
  locationId: number | null;
  startDate: string;
  endDate: string;
}

function toApiDateTime(value: string): string | undefined {
  const trimmed = value.trim();
  if (!trimmed) {
    return undefined;
  }
  const parsed = fromMantineDateString(trimmed);
  if (!parsed) {
    // Invalid picker values are omitted from the request; validation blocks save before this path.
    return undefined;
  }
  return toApiLocalDateTime(parsed) ?? undefined;
}

export function buildMembershipVisitRequest(
  formState: MembershipVisitFormState
): MembershipVisitRequest | null {
  if (formState.locationId == null) {
    return null;
  }

  const request: MembershipVisitRequest = {
    locationId: formState.locationId,
  };

  const startDate = toApiDateTime(formState.startDate);
  const endDate = toApiDateTime(formState.endDate);
  if (startDate) {
    request.startDate = startDate;
  }
  if (endDate) {
    request.endDate = endDate;
  }

  return request;
}
